import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import FormGroup from '../../elements/formElements/FormGroup';
import Select from '../../elements/formElements/Select';

function PostbackForm({ action, postbackData, errors }) {
    const [postback, setPostback] = useState({
        url: '',
        slug: '',
        method: '',
        action: '',
    });
    const history = useHistory();

    useEffect(() => {
        if (postbackData) {
            let postback = {
                url: postbackData.url ?? '',
                slug: postbackData.slug ?? '',
                method: postbackData.method ?? '',
                action: postbackData.action ?? '',
            };
            setPostback(postback);
        }
    }, [postbackData]);

    function handleSubmit(event) {
        event.preventDefault();
        action(postback);
    }

    function cancel() {
        history.push('/postbacks');
    }

    function getErrorFor(field) {
        if (errors[field]) {
            return errors[field][0];
        }
    }

    function getActionOptions() {
        let options = {
            deposit: 'Deposit',
            register: 'Register',
            purchase: 'Purchase',
        };
        return options;
    }

    return (
        <form onSubmit={handleSubmit} autoComplete="do-not-autofill">
            <FormGroup
                type={'text'}
                field={'url'}
                value={postback.url}
                label={'Url'}
                error={getErrorFor('url')}
                handleChange={(event) => setPostback({ ...postback, url: event.target.value })}
            />
            <FormGroup
                type={'text'}
                field={'slug'}
                value={postback.slug}
                label={'Slug'}
                error={getErrorFor('slug')}
                handleChange={(event) => setPostback({ ...postback, slug: event.target.value })}
            />
            <FormGroup
                type={'text'}
                field={'method'}
                value={postback.method}
                label={'Method'}
                error={getErrorFor('method')}
                handleChange={(event) => setPostback({ ...postback, method: event.target.value })}
            />
            <Select
                field={'action'}
                value={postback.action}
                label={'Action'}
                error={getErrorFor('action')}
                options={getActionOptions()}
                handleChange={(event) => setPostback({ ...postback, action: event.target.value })}
            />
            <button type="button" onClick={cancel} className="btn btn-secondary">
                Cancel
            </button>
            <button type="submit" className="btn btn-primary">
                Save
            </button>
        </form>
    );
}

export default PostbackForm;
